const SITE_URL = typeof import.meta !== "undefined" && import.meta.env ? import.meta.env.VITE_SITE_URL || "https://kakobuypolska.mom" : "https://kakobuypolska.mom";
const SITE_NAME = "KakobuyPolska";
const SITE_DESC = "Największa baza Kakobuy Spreadsheet dla polskich użytkowników. Pomagamy szybciej znajdować produkty, analizować oferty i bezpiecznie korzystać z Kakobuy.";

export interface BreadcrumbItem {
  name: string;
  path: string;
}

export function generateBreadcrumbJsonLd(items: BreadcrumbItem[]): string {
  const listItems = items.map((item, i) => ({
    "@type": "ListItem" as const,
    position: i + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`,
  }));
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: listItems,
  });
}

export function generateOrganizationJsonLd(): string {
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: SITE_URL,
    description: SITE_DESC,
    sameAs: [],
  });
}

interface ArticleSchemaParams {
  headline: string;
  description: string;
  datePublished: string;
  dateModified: string;
  imageUrl: string;
  articlePath: string;
}

export function generateArticleJsonLd(params: ArticleSchemaParams): string {
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: params.headline,
    description: params.description,
    image: params.imageUrl,
    datePublished: params.datePublished,
    dateModified: params.dateModified,
    author: {
      "@type": "Organization",
      name: SITE_NAME,
      url: SITE_URL,
    },
    publisher: {
      "@type": "Organization",
      name: SITE_NAME,
      logo: {
        "@type": "ImageObject",
        url: `${SITE_URL}/favicon.png`,
      },
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `${SITE_URL}${params.articlePath}`,
    },
    inLanguage: "pl",
    isAccessibleForFree: true,
  });
}

interface FaqItem {
  question: string;
  answer: string;
}

export function generateFaqJsonLd(faqs: FaqItem[]): string {
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  });
}

export function generateWebSiteJsonLd(): string {
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: SITE_URL,
    description: SITE_DESC,
    inLanguage: "pl",
    potentialAction: {
      "@type": "SearchAction",
      target: `${SITE_URL}/?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  });
}